import { Badge, Button, Table } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import classes from "./UsersTable.module.css";

const formatarData = (dataStr) => {
    if (!dataStr) return '';

    const partes = dataStr.split(' ');
    if (partes.length !== 2) return dataStr;

    const [ano, mes, dia] = partes[0].split('-');
    const hora = partes[1];

    return `${dia}/${mes}/${ano} ${hora}`;
}

export default function UsersTable({ users, userTypes, statusTypes, onEdit, onDelete }) {

    const badgeColor = (status) => {
        if (status === 1) return "success";
        if (status === 0) return "danger";
        return "secondary";
    };

    return (
        <div className="table-responsive">
            <Table bordered className={classes.customTable}>
                <thead className="table-dark">
                    <tr>
                        <th>ID</th>
                        <th>Usuário</th>
                        <th>E-mail</th>
                        <th>Tipo</th>
                        <th>Status</th>
                        <th>Criado em</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>
                    {users.map((l, index) => {

                        const rowStyle = index % 2 === 0
                            ? classes.rowEven
                            : classes.rowOdd;

                        return (
                            <tr key={l.id} className={rowStyle}>

                                <td>{l.id}</td>

                                <td>{l.name}</td>
                                <td>{l.email}</td>

                                <td>
                                    {userTypes.find(t => t.id === l.type)?.title}
                                </td>

                                <td>
                                    <Badge bg={badgeColor(l.active)}>
                                        {l.active === 1 ? "ATIVO" : "INATIVO"}
                                    </Badge>
                                </td>

                                <td className="text-nowrap">
                                    {formatarData(l.created)}
                                </td>

                                <td>
                                    <div className="d-flex justify-content-center">

                                        <Button
                                            size="sm"
                                            variant="outline-primary"
                                            className="me-1"
                                            title="Editar"
                                            onClick={() => onEdit(l)}
                                        >
                                            <FaEdit />
                                        </Button>

                                        <Button
                                            size="sm"
                                            variant="outline-danger"
                                            title="Excluir"
                                            onClick={() => onDelete(l)}
                                        >
                                            <FaTrash />
                                        </Button>

                                    </div>
                                </td>

                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
}